import React from "react";
import {BulletIcon} from "../../../assets";

const audienceItems = [
  "Belum pernah ikut IELTS",
  "Skor kamu stuck di 6.5",
  "Pengen punya jadwal yang fleksibel",
  "Butuh strategi belajar yang personalized",
  "Pengen 1 kelas isinya kamu doang 😉",
];

const SuitForProduct1 = () => {
  return (
    <section className="st-suitfor-section overflow-x-clip px-4 py-14 sm:px-6 sm:py-16 lg:px-8 lg:py-20">
      <div className="mx-auto grid w-full max-w-[1320px] gap-10 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:items-stretch lg:gap-16 xl:gap-20">
        <div className="order-2 lg:order-1">
          <ul className="space-y-4 sm:space-y-5">
            {audienceItems.map((item) => (
              <li
                key={item}
                className="st-suitfor-card flex items-center gap-4 rounded-[22px] px-5 py-5 sm:gap-5 sm:px-6 sm:py-6 lg:px-7 lg:py-7"
              >
                <img
                  src={BulletIcon}
                  alt=""
                  aria-hidden="true"
                  className="h-11 w-11 shrink-0 sm:h-12 sm:w-12"
                  loading="lazy"
                />
                <p className="st-font-body st-suitfor-heading text-[18px] font-semibold leading-[1.2] sm:text-[20px] lg:text-[22px]">
                  {item}
                </p>
              </li>
            ))}
          </ul>
        </div>

        <div className="order-1 lg:order-2 lg:pt-4">
          <div className="max-w-none lg:max-w-[520px] lg:ml-auto lg:flex lg:h-full lg:flex-col lg:justify-between text-right">
            <h2 className="st-font-display mt-6 text-[48px] leading-[0.95] text-[#1a1a1a] sm:text-[62px] lg:mt-0 lg:text-[74px]">
              <span className="italic st-suitfor-title">Program ini </span>
              <span className="font-bold st-suitfor-title">cocok </span>
              <span className="italic st-suitfor-title">untuk kamu yang:</span>
            </h2>

            <p className="st-font-body mt-6 ml-auto max-w-[420px] text-[18px] font-light leading-[1.35] st-suitfor-footer sm:text-[20px] lg:mt-8 lg:text-[22px]">
              <span className="block font-bold">Relate? <span className="font-light">Berarti ini</span></span>
              <span className="font-light">program yang kamu<span className="font-bold"> cari!</span></span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuitForProduct1;